<template>
  <div id="footer">
    <div class="footer-top">
      <v-flex xs12 sm12 md10 offset-md1>
        <v-container row>
          <v-layout align-center justify-center fill-height wrap>
            <v-flex xs12 sm3 md2>
              <v-img
                :src="require('@/assets/sistesi-with-name.svg')"
                class="icon-sistesi mr-4 mb-4"
              ></v-img>
            </v-flex>
            <v-flex xs12 sm9 md8 align-self-start>
              <v-layout align-start justify-center fill-height wrap>
                <v-flex xs12 sm5 md5 class="menu-wrapper pr-">
                  <!-- <div class="footer-title-top">
                    <span>{{ $t("aboutus") }}</span>
                  </div> -->
                  <div class="footer-body-top">
                    <div class="btn-footer">
                      <a href="https://www.exiglosi.com/" target="_blank">{{
                        $t("about_exi")
                      }}</a>
                    </div>
                    <div class="btn-footer">
                      <a @click="toContactUsHandler()">{{
                        $t("contact_us")
                      }}</a>
                    </div>
                    <div class="btn-footer">
                      <a @click="toPrivasiHandler()">{{
                        $t("privacy_policy")
                      }}</a>
                    </div>
                    <div class="btn-footer">
                      <a @click="toTermHandler()">{{
                        $t("term_and_condition")
                      }}</a>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 md6 class="menu-wrapper">
                  <div class="footer-title-top">
                    <span>{{ $t("followus") }}</span>
                  </div>
                  <div class="footer-body-top">
                    <v-layout
                      class="mb-2"
                      align-start
                      justify-center
                      fill-height
                      wrap
                    >
                      <v-flex xs12 sm12 md12>
                        <a
                          v-for="(d, index) in icons"
                          :key="index"
                          :href="d.link"
                          class="pr-2"
                          target="_blank"
                        >
                          <img :src="d.icon" style="width: 39px" />
                        </a>
                      </v-flex>
                    </v-layout>
                    <div class="d-flex">
                      <a
                        href="https://play.google.com/store/apps/details?id=id.sistesi"
                        target="_blank"
                      >
                        <v-img
                          :src="require('@/assets/play-store.svg')"
                          style="max-width: 160px; height: 100%"
                          class="mr-2"
                        ></v-img>
                      </a>
                      <a
                        href="https://apps.apple.com/us/app/sistesi/id1483575691?ls=1"
                        target="_blank"
                      >
                        <v-img
                          :src="require('@/assets/app-store.svg')"
                          style="max-width: 160px; height: 100%"
                        ></v-img>
                      </a>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </div>
    <div class="footer-bottom">
      <span
        >Copyrights © {{ thisYear }} EXI Global Aplikasi. All Rights
        Reserved.</span
      >
    </div>
  </div>
</template>

<script>
import Facebook from "@/assets/svg/facebook.svg";
import Gmail from "@/assets/svg/gmail.svg";
import Instagram from "@/assets/svg/instagram.svg";
import Linkedin from "@/assets/svg/linkedin.svg";
import Twitter from "@/assets/svg/twitter.svg";
import Youtube from "@/assets/svg/youtube.svg";

import router from "@/router";
import moment from "moment";
import store from "@/stores";
import { setTimeout } from "timers";
moment.locale("id");

import posed from "vue-pose";

export default {
  components: {
    Box: posed.div({
      hoverable: true,
      init: { scale: 1 },
      hover: { scale: 1.1 }
    })
  },
  data: () => ({
    icons: [
      { icon: Facebook, link: "https://web.facebook.com/exiglosiofficial" },
      { icon: Twitter, link: "https://twitter.com/exiglosioffici4" },
      {
        icon: Linkedin,
        link: "https://id.linkedin.com/company/exi-global-aplikasi"
      },
      { icon: Instagram, link: "https://www.instagram.com/exiglosiofficial/" }
    ],
    thisYear: moment().format("YYYY")
  }),
  methods: {
    toTermHandler(val) {
      store.commit("isLoading", true);
      setTimeout(() => {
        store.commit("isLoading", false);
        router.push({ name: "TermAndCondition" });
        window.scrollTo(0, 0);
      }, 1000);
    },
    toPrivasiHandler() {
      store.commit("isLoading", true);
      setTimeout(() => {
        store.commit("isLoading", false);
        router.push({ name: "PrivacyPolicies" });
        window.scrollTo(0, 0);
      }, 1000);
    },
    toContactUsHandler() {
      store.commit("isLoading", true);
      setTimeout(() => {
        store.commit("isLoading", false);
        router.push({ name: "ContactUs" });
        window.scrollTo(0, 0);
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
#footer {
  position: relative;
  background-color: #eaeaea;
  .footer-top {
    padding: 30px 100px;
    .footer-title-top {
      margin-bottom: 12px;
      span {
        font-weight: 700;
        font-size: 15px;
      }
    }
    .btn-footer {
      margin: 10px 0;
      a {
        color: #000000;
        text-decoration: none;
        &:hover {
          color: #27ace2;
        }
      }
    }
    .icon-sistesi {
      img {
        height: 150px;
      }
    }
    .followus {
      margin-bottom: 20px;
    }
  }
  .footer-bottom {
    background-color: #dad8d8;
    padding: 15px 100px;
    text-align: center;
    span {
      font-size: 12px;
    }
  }
  .icon-bg {
    background-color: rgba(255, 255, 255, 1);
    border-radius: 50%;
    padding: 10px;
  }
  @media only screen and (max-width: 600px) {
    .footer-bottom,
    .footer-top {
      text-align: center;
      padding: 20px;
    }
    .icon-sistesi {
      display: none;
    }
    .followus {
      margin-bottom: 40px !important;
    }
  }

  @media only screen and (max-width: 600px) {
    .menu-wrapper {
      &:last-child {
        padding-top: 25px;
      }
    }
  }
}
</style>
